export default {
    title_list: 'Members',
    title_page: 'Member',
    title_create_page: 'Create user',
    title_edit_page: 'Change user',

    labels: {
        subscriptions: 'Memberships',
        transactions: 'Payment transactions',
        drag_in_drop: 'Drag or click to select files',
        date: 'Date',
        braintree_id: 'Braintree ID',
        subscription: 'Membership',
        subscription_start: 'Date start',
        subscription_end: 'Expiration date',
        plan: 'Tariff plan',
        gifts: 'Presents',
        gift: 'Present',
        price: 'The cost',
        cost: 'The cost',
        card: 'Card',
        recipient: 'Recipient',
        how_know: 'How did you hear?',
    },

    filter: {
        labels: {
            name: 'Nickname',
            first_name: 'First name',
            last_name: 'Last name',
            email: 'Email',
            subscription: 'Membership',
            greenhouse: 'Greenhouse member',
            is_pro: 'ARTIPro member',
        }
    },

    table: {
        labels: {
            id: 'ID',
            name: 'Nickname',
            first_name: 'First name',
            last_name: 'Last name',
            email: 'Email',
            provider: 'Provider',
            subscription: 'Membership',
            count_artifacts: 'Count Artifcts',
            how_know: 'How did you hear?',
            greenhouse: 'Greenhouse',
            is_pro: 'ARTIPro',
        }
    },

    buttons: {

    },

    form: {
        name: 'Nickname',
        email: 'Email',
        preserve_email: 'Trusted email',
        email_verified_at: 'Email confirmation date',
        first_name: 'First name',
        last_name: 'Last name',
        middle_name: 'Middle name',
        photo: 'Avatar',
        year: 'Year of birth',
        month: 'Month of birth',
        password: 'Password',
        created_at: 'Date of creation',
        updated_at: 'Date of change',
        provider: 'Authorization Provider',
        provider_id: 'Authorization provider ID',
        type_id: 'Type',
        greenhouse: 'Greenhouse member',
        email_notifications: 'Turn off email notifications',
        is_pro: 'ARTIPro member',
        brain_health_id: 'Brain health ID',
    },
}
